import React, { useEffect, useState } from "react";

import { Row, Col, Spin, Typography } from "antd";
import {
  WomanOutlined,
  ManOutlined,
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  LoadingOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import TableComponent from "../../../components/Table/TableComponent";

import { patientListInProgress } from "../../../appRedux/doctor/actions/patient";
import ButtonComponent from "../../../components/Button/ButtonComponent";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { getAppointmentByDoctorPatientInProgress } from "../../../appRedux/Patient/Action/Action";
import moment from "moment";

const ViewAppoinment = () => {
  const location = useLocation();
  const patientId = location.state;
  console.log("xzzzzzzzzzzzzzzzzz", location.state);
  const doctorId = localStorage.getItem("doctor_id");
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 72,
      }}
      spin
    />
  );
  const columns = [
    {
      title: "First Name",
      dataIndex: "firstName",
    },

    {
      title: "Last Name",
      dataIndex: "lastName",
    },
    {
      title: "DOB",
      dataIndex: "dob",
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Address1",
      dataIndex: "address1",
    },

    { title: "Appointment", dataIndex: "appointment_name" },
  ];
  const dispatch = useDispatch();
  const singlePatientData = useSelector(
    (state) => state.patient.getSingleHealthRecord
  );
  const doctorData = useSelector(
    (state) => state?.patientAppointment?.appoitmnetsByDoctorPatient
  );
  const history = useHistory();
  const doctorList = doctorData?.data;
  console.log("doctorDatadoctorDatadoctorDatadoctorDatadoctorData", doctorList);
  const [Loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState("");
  const totalRecords = singlePatientData?.data?.totalRecords;
  const handlePage = (page) => {
    dispatch(patientListInProgress(page));
  };
  const handleSelectChange = (value) => {
    if (value === "all") {
      setFilteredUsers(doctorList);
    } else {
      const newData = doctorList.slice(0, value);
      setFilteredUsers(newData);
    }
  };
  const CurrentDate = moment().format("YYYY-MM-DD");
  const CurrentTime = moment().format("hh:mmA");
  const day = moment().format("A");
  console.log("CurrentTime", CurrentTime);
  const goBackHandler = () => {
    history.goBack();
  };
  useEffect(() => {
    const formData = new FormData();
    formData.append("patient_id", localStorage.getItem("patient_id"));
    formData.append("doctor_id", doctorId);
    formData.append("current_time", CurrentTime);
    formData.append("current_date", CurrentDate);
    console.log(
      "formDataformDataformDataformDataformData",
      formData?.patientId
    );
    dispatch(
      getAppointmentByDoctorPatientInProgress({
        patient_id: patientId,
        doctor_id: localStorage.getItem("doctor_id"),
        current_time: CurrentTime,
        current_date: CurrentDate,
      })
    );
  }, [patientId]);

  useEffect(() => {
    if (singlePatientData?.inProgress) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [singlePatientData?.inProgress]);
  return (
    <Spin indicator={antIcon} spinning={Loading}>
      <Row>
        <Col xl={24} lg={24} md={24} xs={24} sm={24}>
          <Row justify={"space-between"} className="margin-row">
            <Col>
              <Typography className="view-header">
                Patient Appointment History
              </Typography>
            </Col>
            <Col>
              <ButtonComponent
                type="danger"
                icon={<ArrowLeftOutlined />}
                onClick={goBackHandler}
                size="small"
              />
            </Col>
          </Row>
        </Col>
        <Col xl={24} lg={24} md={24} xs={24} sm={24}>
          <TableComponent
            columns={columns}
            dataSource={filteredUsers ? filteredUsers : doctorList || []}
            pagination={{
              total: totalRecords,
              onChange: (page) => handlePage(page),
            }}
            itemList={doctorList}
            filteredUsers={filteredUsers}
            setFilteredUsers={setFilteredUsers}
            field={"firstName"}
            rowselector={handleSelectChange}
          />
        </Col>
      </Row>
    </Spin>
  );
};

export default ViewAppoinment;
